import { useEffect } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import Home from "pages/Home";
import { useAuth } from "AuthContext";

import FullMask from "layout/FullMask";
import MessagePage from "components/MessagePage";
import Login from "pages/Login";
import ForgetPassword from "pages/ForgetPassword";

import { Button } from "antd";
import { SmileOutlined } from "@ant-design/icons";
import SendWeddingWishPage from "pages/SendWeddingWishPage";
import WeddingWishReviewPage from "pages/WeddingWishReviewPage";
import ShowWeddingWishes from "pages/ShowWeddingWishes";
import Invitations from "pages/Invitations";
import InvitationForm from "pages/InvitationForm";

function NotFound({ permission }) {
    useEffect(() => {
        document.title = `Điền Trang - ${
            permission ? "Không có quyền truy cập" : "Trang không tồn tại"
        }`;
        // eslint-disable-next-line
    }, []);

    const navigate = useNavigate();
    return (
        <MessagePage
            status={permission ? "403" : "404"}
            title="OOPS"
            subTitle={
                permission
                    ? "Bạn không có quyền truy cập vào trang này."
                    : "Trang bạn cố gắng truy cập không tồn tại."
            }
            extra={
                <Button type="primary" onClick={() => navigate("/")}>
                    Trở về trang chủ
                </Button>
            }
        />
    );
}

export { NotFound };

function Implementing() {
    const navigate = useNavigate();
    return (
        <MessagePage
            icon={<SmileOutlined />}
            title="Chúng tôi đang phát triển tính năng này, bạn vui lòng đợi bản cập nhật trong tương lai nhé!"
            extra={
                <Button type="primary" onClick={() => navigate("/")}>
                    Trở về trang chủ
                </Button>
            }
        />
    );
}

var setHeaderG;

function Ro({ element, hasHeader = true, allowRole = 0 }) {
    const navigate = useNavigate();
    const location = useLocation();
    const { user, firstGettingUser } = useAuth();

    if (allowRole !== null && firstGettingUser) return <FullMask />;
    if (allowRole !== null && !user) {
        navigate(`/login?next=${location.pathname}`);
        return null;
    }
    if (allowRole !== null && user.role > allowRole) {
        return <NotFound permission />;
    }
    setHeaderG(hasHeader);
    return element;
}

export default function AppRoute({ setHeader }) {
    setHeaderG = setHeader;

    return (
        <Routes>
            <Route
                path=""
                element={<Ro element={<Home />} allowRole={null} />}
            />
            <Route
                path="/:place/:code"
                element={<Ro element={<Home />} allowRole={null} />}
            />
            {/* base */}
            <Route
                path="/login"
                element={
                    <Ro
                        hasHeader={false}
                        element={<Login />}
                        allowRole={null}
                    />
                }
            />
            <Route
                path="/forget-password"
                element={
                    <Ro
                        hasHeader={false}
                        element={<ForgetPassword />}
                        allowRole={null}
                    />
                }
            />

            <Route
                path="/send-wedding-wish"
                element={
                    <Ro
                        hasHeader={false}
                        element={<SendWeddingWishPage />}
                        allowRole={null}
                    />
                }
            />

            <Route
                path="/wedding-wish-review"
                element={
                    <Ro
                        hasHeader={false}
                        element={<WeddingWishReviewPage />}
                        allowRole={100}
                    />
                }
            />
            
            <Route
                path="/show-wedding-wishes"
                element={
                    <Ro
                        hasHeader={false}
                        element={<ShowWeddingWishes />}
                        allowRole={null}
                    />
                }
            />

            <Route
                path="/invitations"
                element={
                    <Ro
                        element={<Invitations />}
                        allowRole={100}
                    />
                }
            />

            <Route
                path="/invitation-form"
                element={
                    <Ro
                        element={<InvitationForm />}
                        allowRole={null}
                    />
                }
            />

            <Route
                path="*"
                element={
                    <Ro
                        element={<NotFound />}
                        allowRole={null}
                    />
                }
            />
        </Routes>
    );
}
